import { backofficeRequest } from '../../../axios'

export const getEmailsHistory = async ({
  page = 1,
  rowsPerPage = 25,
  senderId = null,
  mandat = '',
  recipientEmail = '',
  coproId = null,
}) => {
  try {
    const { data } = await backofficeRequest.get('backoffice/emails', {
      params: {
        page: page,
        per: rowsPerPage,
        senderId,
        mandat,
        recipientEmail,
        coproId,
      },
    })
    return data
  } catch (error) {
    return error
  }
}

export const getAllUsers = async () => {
  try {
    const { data } = await backofficeRequest.get('backoffice/users/emails')
    return data
  } catch (error) {
    return error
  }
}
